/**
 * Raqam va matn formatlash — docs/DESIGN_TOKENS.md §13.
 *
 * Ming ajratgich — BUZILMAS PROBEL (U+00A0), vergul yoki nuqta emas.
 * Prototipdagi `fmt` funksiyasi bilan aynan bir xil.
 */

const NBSP = ' ';

/** `2480` → `2 480` (buzilmas probel bilan). */
export function fmt(n: number): string {
  return String(Math.trunc(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

/**
 * Qisqartirilgan raqam: `84200` → `84.2K` (prototipdagi statistika kartasi).
 *
 * Faqat TOR joyda — yarim ekranli kartada `84 200` sig'maydi. Balans va
 * narx hech qachon qisqartirilmaydi: u yerda aniq raqam kerak.
 */
export function compact(n: number): string {
  const value = Math.trunc(n);
  if (value < 10_000) return fmt(value);

  const [divisor, suffix] = value < 1_000_000 ? [1_000, 'K'] : [1_000_000, 'M'];
  const scaled = value / divisor;
  // 84.0K emas, 84K — ortiqcha nol o'qishni sekinlashtiradi.
  return `${scaled.toFixed(1).replace(/\.0$/, '')}${suffix}`;
}

/** Taymer: `65` → `1:05`. */
export function duration(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = Math.floor(totalSeconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * O'rin yorlig'i — KASR EMAS, MA'NO (qoida 19).
 *
 * `9/12` — xato. Foydalanuvchi kasrni o'qib, ayirishi kerak bo'ladi.
 */
export function seatsLabel(free: number): string {
  if (free <= 0) return 'O‘RIN QOLMADI';
  return `${free}${NBSP}O‘RIN BO‘SH`;
}
